import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { throwError } from '../../../throwError';
import { handleError } from '../../../handleError';
import { api } from '../../../../server/api';

export function* createChannel({ payload }) {
  try {
    yield effects.put(chatActions.startFetching());
    const response = yield effects.apply(api, api.post, [
      {
        endpoint: 'chats/',
        headers: {
          'X-Report-ID': payload,
        },
      },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    yield effects.put(chatActions.fetchChannels());
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
